import { render, staticRenderFns } from "./ProductMachine.vue?vue&type=template&id=2890498c&scoped=true"
import script from "./ProductMachine.vue?vue&type=script&lang=js"
export * from "./ProductMachine.vue?vue&type=script&lang=js"
import style0 from "./ProductMachine.vue?vue&type=style&index=0&id=2890498c&prod&lang=css"
import style1 from "./ProductMachine.vue?vue&type=style&index=1&id=2890498c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2890498c",
  null
  
)

export default component.exports